module.exports = __webpack_public_path__ + "static/media/question-square.8d4d9af8.svg";